import type { TOC } from '@ember/component/template-only';
import t from 'ember-intl/helpers/t';
import type ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
import Slider from 'parog-web/components/mici/base-consult-form/slider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    forcComponent: ForcJournalEventBasedComponent;
  };
}

export default <template>
  <Slider @form={{@form}} @forcComponent={{@forcComponent}} @key='lowMood'>
    <:header>
      <div>
        <div class='text-black'>{{t
            'mici-form.lowMood.long'
            htmlSafe=true
          }}</div>
      </div>
    </:header>
    <:lowest>
      Je ne suis pas du tout d'accord (0)
    </:lowest>
    <:highest>
      Je suis tout à fait d'accord (10)
    </:highest>
  </Slider>
</template> satisfies TOC<Signature>;
